import { render } from "./RuleEditor.vue?vue&type=template&id=2788a254&scoped=true"
import script from "./RuleEditor.vue?vue&type=script&lang=js"
export * from "./RuleEditor.vue?vue&type=script&lang=js"

import "./RuleEditor.vue?vue&type=style&index=0&id=2788a254&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2788a254"]])

export default __exports__